const formatCurrency = (value) => {
    const formatting_options = {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
    };
    const num = Number(value);
    return Number.isFinite(num)
        ? num.toLocaleString('id-ID', formatting_options)
        : (0).toLocaleString('id-ID', formatting_options);
};

export default formatCurrency;
